// Internal modules
import type { GenericObjectType } from '@/types';
import { logger } from '../logger';

type GQLErrorResponse = {
  error: any;
  errorData: any;
  isFiConfirmationContingency: boolean;
  isOasError: boolean;
  isOpenBankingTerminalError: boolean;
  isResidentialAddressError: boolean;
  isRiskPhoneConfirmationContingency: boolean;
  isWorldReadyIdentityDocumentError: boolean;
  message: any;
};
const parseGqlError = (result: GenericObjectType = {}): GQLErrorResponse => {
  /**
   * `result?.response?.errors?.[0]`:
   * `graphql-request` uses an Error object wrapper with the request and
   * response information. In this case `result.response` is the response
   * from the network call.
   * https://github.com/prisma/graphql-request/blob/v1.8.2/src/types.ts#L38
   *
   * `result`:
   * This is used when the we manually throw an error
   *
   * TODO replace this with only using result since we no longer use
   * graphql-request
   */
  const error = result?.response?.errors?.[0] || result;
  const { data, errorData, message = '' } = error;

  if (errorData?.length === 1) {
    if (errorData[0] === null || errorData[0] === undefined) {
      errorData.shift();
    }
  }

  return {
    error,
    errorData: errorData || data || [],
    isFiConfirmationContingency: message === 'FI_CONFIRMATION_CONTINGENCY',
    isOasError: message === 'OAS_ERROR',
    isOpenBankingTerminalError: message === 'OPEN_BANKING_TERMINAL_ERROR',
    isResidentialAddressError:
      message === 'RESIDENTIAL_ADDRESS_VALIDATION_ERROR',
    isRiskPhoneConfirmationContingency:
      message === 'RISK_PHONE_CONFIRMATION_TEST',
    isWorldReadyIdentityDocumentError:
      message === 'IDENTITY_DOCUMENT_VALIDATION_ERROR',
    message,
  };
};

/**
 * @function validateGraphQLResponse
 * @param {object} data
 * @param {string} operation
 * @description Checks if the response of a GraphQL call has an error
 * attached to it and if it does an Error is thrown.
 */
const validateGraphQLResponse = (
  data: GenericObjectType,
  operation: string,
  errorMessage: string,
): void => {
  const error = data?.errors?.[0];

  if (error) {
    logger.error(`weasley_${operation}_err`, {
      message: error.message,
    });
    throw new Error(errorMessage || error.message);
  }

  logger.info(`weasley_${operation}_success`);
};

export { parseGqlError, validateGraphQLResponse };
